// Tabla de rutas — ruteo liviano por pathname (la SPA no usa react-router).
// Agregar una página es data-only: una entrada más acá. El fallback es la Landing.

import type { ReactNode } from 'react';
import { Landing } from '@/app/Landing';
import { PageLayout } from '@/layout/PageLayout';
import { LegalPage } from '@/legal/LegalPage';
import { SupportPage } from '@/support/SupportPage';

interface Route {
  test: (pathname: string) => boolean;
  render: () => ReactNode;
}

// Match exacto, tolerando un '/' final (cleanUrls + trailingSlash:false en Vercel).
const exact = (path: string) => (p: string) => p === path || p === `${path}/`;

const routes: Route[] = [
  {
    test: exact('/terms'),
    render: () => (
      <PageLayout>
        <LegalPage slug="terms" />
      </PageLayout>
    ),
  },
  {
    test: exact('/privacy'),
    render: () => (
      <PageLayout>
        <LegalPage slug="privacy" />
      </PageLayout>
    ),
  },
  {
    test: exact('/soporte'),
    render: () => (
      <PageLayout>
        <SupportPage />
      </PageLayout>
    ),
  },
];

export function resolveRoute(pathname: string): ReactNode {
  const match = routes.find((r) => r.test(pathname));
  return match ? match.render() : <Landing />;
}
